import _map from 'lodash/map'
import React from 'react'
import SelectTimeSlotTicketsAddons from '../_library/SelectMultipleTimeSlots/SelectTimeSlotTicketsAddons'

const ticketTypesSorting = tickets => {
  const noGroupedTickets = []
  const groupedTickets = []
  const groupedTicketsMap = {}
  tickets.forEach(el => {
    if (el.slotGroupId) {
      if (groupedTicketsMap[el.slotGroupId]) {
        groupedTicketsMap[el.slotGroupId].tickets.push(el)
      } else {
        groupedTicketsMap[el.slotGroupId] = {
          tickets: [el],
          groupName: el.slotGroupName,
          groupId: el.slotGroupId,
        }
      }
    } else {
      noGroupedTickets.push(el)
    }
  })
  for (const key in groupedTicketsMap) {
    groupedTickets.push(groupedTicketsMap[key])
  }
  return [noGroupedTickets, groupedTickets]
}

const TicketsSection = props => {
  const { tickets, tables, enableAddOnsWithVariants, groupedTicketIds, setTicketTypePreRequired } = props
  const [noGroupedTickets, groupedTickets] = ticketTypesSorting(tickets)

  const onChangeNoGroupedTickets = e => {
    const { id } = e.target
    const { checked } = e.target
    const newNoGroupedTicketsIds = [...groupedTicketIds]
    if (checked) {
      newNoGroupedTicketsIds.push(id)
    } else {
      const index = newNoGroupedTicketsIds.indexOf(id)
      if (index !== -1) {
        newNoGroupedTicketsIds.splice(index, 1)
      }
    }
    setTickets(newNoGroupedTicketsIds)
  }

  const setTickets = (noGroupedTicketsIds = []) => {
    setTicketTypePreRequired(noGroupedTicketsIds)
  }

  const onChangeGroupedTickets = (e, groupId) => {
    const selectedGroup = groupedTickets.find(g => g.groupId === groupId).tickets.map(ticket => ticket.id)
    const newGroupedTicketIds = groupedTicketIds.filter(ticket => !selectedGroup.includes(ticket))    
    setTickets([...newGroupedTicketIds, ...e])
  }

  return (
    <div
      className="row col-xl-6"
      style={{
        background: '#2f3339',
        margin: '20px 10px',
        padding: ' 0 0px 10px',
      }}
    >
      <div className="col-sm-6 col-xs-12" style={{ margin: '5px 0' }}>
        <label htmlFor={'add-on-ticketType'}>Ticket Type</label>
        {_map(noGroupedTickets, (t, index) => (
          <div key={index} className="d-flex">
            <input
              type="checkbox"
              id={t.id}
              name={t.id}
              checked={groupedTicketIds.includes(t.id)}
              onChange={onChangeNoGroupedTickets}
            />
            <label style={{ marginLeft: '10px' }} htmlFor={t.id}>
              {t.displayName}
            </label>
          </div>
        ))}
        {groupedTickets.length ? (
          <SelectTimeSlotTicketsAddons
            defaultTicketIds={groupedTicketIds}
            groupedTickets={groupedTickets}
            onChange={(v, groupId) => {
              onChangeGroupedTickets(v, groupId)
            }}
          />
        ) : null}
      </div>
      {!enableAddOnsWithVariants && (
        <div className="col-sm-6 col-xs-12" style={{ margin: '5px 0' }}>
          <label htmlFor={'add-on-ticketType'}>Table Type</label>
          {_map(tables, (t, index) => (
            <div key={index} className="d-flex">
              <input
                type="checkbox"
                id={t.id}
                name={t.id}
                checked={groupedTicketIds.includes(t.id)}
                onChange={onChangeNoGroupedTickets}
              />
              <label style={{ marginLeft: '10px' }} htmlFor={t.id}>
                {t.displayName}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default TicketsSection